import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-set-credit-card-fee',
  templateUrl: './set-credit-card-fee.component.html',
  styleUrls: ['./set-credit-card-fee.component.css']
})
export class SetCreditCardFeeComponent implements OnInit {

  feeActual: string = 'Sin configurar';
  nuevoFee: number = 0;

  constructor(private afs: AngularFirestore) {}

  ngOnInit(): void {
    this.afs.collection('fee').doc('creditcard').get().subscribe((snap: any) => {
      if (snap.exists && snap.data()?.percentage != null) {
        const p = snap.data().percentage;
        this.feeActual = (p * 100).toFixed(3) + '%';
        this.nuevoFee = p * 100;
      }
    });
  }

  guardar(): void {
    const valorGuardado = this.nuevoFee / 100;
    this.afs.collection('fee').doc('creditcard').set({ percentage: valorGuardado }, { merge: true })
      .then(() => {
        this.feeActual = this.nuevoFee.toFixed(3) + '%';
        Swal.fire({ icon: 'success', title: 'Fee actualizado', text: `Nuevo fee: ${this.nuevoFee}%`, timer: 2000, showConfirmButton: false });
      })
      .catch(() => {
        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo guardar el fee' });
      });
  }
}
